import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as _ from 'lodash';
import {LogicalConjunctionService} from '../../../../services/common/logical-conjunction/logical-conjunction.service';
import {ChooseTopologyElementFromMapService} from '../../../../utils/choose-topology-item/services/choose-topology-element-from-map/choose-topology-element-from-map.service';

@Component({
  selector: 'routing-rule-dialog-source',
  templateUrl: './routing-rule-dialog-source.component.html',
  styleUrls: ['./routing-rule-dialog-source.component.less']
})
export class RoutingRuleDialogSourceComponent implements OnInit, OnChanges {

  @Input() source: any;
  @Input() adminState: string;
  @Input() externalData: any;

  nodes: any;
  pCons: any;
  userGroups: any;
  prefixGroups: any;
  resourceGroups: any;
  customers: any;
  logicalConjunctionNotice: string;
  mapOptions;

  constructor(private logicalConjunctionService: LogicalConjunctionService,
              private ChooseTopologyElementsFromMapService: ChooseTopologyElementFromMapService) {
  }

  ngOnInit(): void {
    this.initialize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (typeof changes.adminState !== 'undefined') {
      const change = changes.adminState;
      if (!change.isFirstChange()) {
        this.setNodesAndPConsLists();
      }
    }
  }

  initialize(): void {
    this.setNodesAndPConsLists();
    this.userGroups = this.externalData.userGroups;
    this.prefixGroups = this.externalData.prefixGroups;
    this.resourceGroups = this.externalData.resourceGroups.filter(group => group.displayType !== 'VoIP Peer');
    this.customers = this.externalData.customers;
    this.updateLogicalConjunctionNotice();
    this.initializeMap();
  }

  setNodesAndPConsLists(): any {
    _.isEqual(this.adminState, 'LOCKED') ? this.setNodesAndPConsWithOffline() : this.setNodesAndPConsWithoutOffline();
  }

  setNodesAndPConsWithOffline(): void {
    this.setNodesWithOffline();
    this.setPConsWithOffline();
  }

  setNodesWithOffline(): void {
    this.nodes = [...this.externalData.nodes, ...this.externalData.offlineNodes];
  }

  setPConsWithOffline(): void {
    const filteredPCons = this.externalData.pCons.filter(pCon => pCon.peerConnectionNodeType !== 'Virtual');
    const filteredOfflinePCons = this.externalData.offlinePCons.filter(pCon => pCon.peerConnectionNodeType !== 'Virtual');

    this.pCons = [...filteredPCons, ...filteredOfflinePCons];
  }

  setNodesAndPConsWithoutOffline(): void {
    this.nodes = this.externalData.nodes;
    this.pCons = this.externalData.pCons.filter(pCon => pCon.peerConnectionNodeType !== 'Virtual');
  }

  initializeMap(): void {
    const withOffline = this.adminState === 'LOCKED';
    const isSelectionLegal = () => {
      return true;
    };

    this.mapOptions = this.ChooseTopologyElementsFromMapService.prepareOptionsForNodesAndPCons(isSelectionLegal, withOffline,
      this.source.nodes, this.source.pCons, this.nodes, this.pCons, 'rule-source-nodes-selection');
  }

  updateLogicalConjunctionNotice(): void {
    const andItems = [];
    const orItems = [];

    if (!_.isEmpty(this.source.rrAttrs.prefix)) { andItems.push('Prefix'); }
    if (!_.isEmpty(this.source.rrAttrs.host)) { andItems.push('Host'); }
    if (!_.isEmpty(this.source.userGroups)) { andItems.push('User Group'); }
    if (!_.isEmpty(this.source.sourceCustomers) || this.source.allCustomers) { andItems.push('Customers'); }
    if (!_.isEmpty(this.source.reroutePcons)) { andItems.push('Reroute Peer Connection'); }

    if (!_.isEmpty(this.source.resourceGroups)) { orItems.push('Resource Group'); }
    if (!_.isEmpty(this.source.nodes)) { orItems.push('Node'); }
    if (!_.isEmpty(this.source.pCons)) { orItems.push('Peer Connection'); }

    this.logicalConjunctionNotice = this.logicalConjunctionService.generateNoticeMessage(andItems, orItems);
  }

  onMapClick($event: any): void {
    this.source.nodes = $event.node.map(nodeItem => nodeItem.dataItem.id);
    this.source.pCons = $event.pCon.filter(item => item.dataItem.peerConnectionNodeType !== 'Virtual')
      .map(pConItem => pConItem.dataItem.id);
  }
}
